// extracted by mini-css-extract-plugin
export var LanguageSwitcher = "LanguageSwitcher-module--LanguageSwitcher--d4bNy";
export var language = "LanguageSwitcher-module--language--u-QxM";